<template>
  <div class="SplittingText">
    <span ref="target" v-html="text">{{ text }}</span>
  </div>
</template>

<script>

import Splitting from "splitting";

import { Expo, TweenLite, TimelineLite } from 'gsap'

// Add direction attrubite ? animate out top or bottom
export default {
  name: 'SplittingText',
  props: {
    text: String,
    outDirection: Number
  },
  data() {
    return {
      words: null
    }
  },
  mounted() {
    let results = Splitting( { target: this.$refs.target, by: 'lines' } )

    this.words = results[0].words

    this.words.forEach( ( word, index ) => {
      TweenLite.to( word, 0, { opacity: '0', y: '40%' } )
    } )

    this.createWordSwitchTimeline()
  },
  computed: {
  },
  methods: {
    createWordSwitchTimeline() {
      let word = this.words[this.words.length - 1 ]
      let prevWord = this.words[this.words.length - 2 ]

      // TweenLite.to( prevWord, 0.6, { y: '-20%', opacity: '0', delay: 0 } )
      // TweenLite.to( word, 0.7, { y: '-20%', opacity: '0', delay: 0 } )
      //
      // TweenLite.to( prevWord, 0, { y: '40%', opacity: '0', delay: 0.6, ease: Expo.easeOut } )
      // TweenLite.to( word, 0, { y: '40%', opacity: '0', delay: 0.6, ease: Expo.easeOut } )
      //
      // setTimeout( () => {
      //   word.innerHTML = "continue"
      // }, 600 )
      //
      // TweenLite.to( prevWord, 0.6, { y: '0%', opacity: '1', delay: 0.6, ease: Expo.easeOut } )
      // TweenLite.to( word, 0.6, { y: '0%', opacity: '1', delay: 0.7, ease: Expo.easeOut } )

      this.animateWordChange = new TimelineLite( { paused: true } )

      this.animateWordChange
        .to( prevWord, 0.6, { opacity: '0', y: '-20%', ease: Expo.easeOut }, 0 )
        .to( word, 0.7, { opacity: '0', y: '-20%', ease: Expo.easeOut }, 0.1 )
        .to( prevWord, 0, { y: '40%', ease: Expo.easeOut }, 0.6 )
        .to( word, 0, { y: '40%', ease: Expo.easeOut }, 0.7 )
        .add( () => { word.innerHTML = "continue" }, 0.6 )
        .to( prevWord, 0.6, { opacity: '1', y: '0%', ease: Expo.easeOut }, 0.6 )
        .to( word, 0.7, { opacity: '1', y: '0%', ease: Expo.easeOut }, 0.7 )

    },
    animateTextIn() {
      this.words.forEach( ( word, index ) => {
        TweenLite.to( word, 1.5 + index / 10, { opacity: '1', y: '0%', delay: 0.5 * index / 10, ease: Expo.easeOut } )
      } )
    },
    animateTextOut() {
      this.words.forEach( ( word, index ) => {
        TweenLite.to( word, 0.8 + index / 10, { opacity: '0', y: this.outDirection > 1 ? '40%' : '-40%', delay: 0.25, ease: Expo.easeOut } )
      } )
    },
    hideText() {
      this.words.forEach( ( word, index ) => {
        TweenLite.to( word,0.5, { opacity: '0', delay: 0, ease: Expo.easeOut } )
      } )
    },
    updateWord() {

      this.animateWordChange.play()

    }
  }
}
</script>

<style lang="scss">

  @import '@/styles/core.scss';

  .SplittingText {

    .splitting .word {

      display: inline-block;

      backface-visibility: hidden;
      -webkit-backface-visibility: hidden;

    }

  }

</style>
